import { engineComponent, NumberUtils } from "neo-common";
import { Communication } from "neo-games";
import { ComponentTypes } from "../Components/ComponentTypes";
import { Symbol } from "../GameComponents/Symbol";
import { WinAnimator } from "../GameComponents/WinAnimator";
import { Payline } from "../GameComponents/Payline";
import { Symbols } from "../GameComponents/Symbols";
import { Paylines } from "../GameComponents/Paylines";
import { ContainerElement } from "../Components/Elements/Graphics/ContainerElement";
import { GameManager } from "../Managers/GameManager";
import { Settings } from "./Settings";
import { SwitchElement } from "../Components/Elements/Graphics/SwitchElement";
import { ISymbolTeasingAttributes, SymbolTeasingActions, TeasingComponentAbstract } from "./TeasingComponentAbstract";
import { Tweens } from "../Components/Effects/Tweens";
import { ModuleManager } from "../Managers/ModuleManager";
import { TimelineElement } from "../Components/Elements/Graphics/TimelineElement";
import { ImageTextCounterElement } from "../Components/Elements/Texts/ImageTextCounterElement";
import { BetManager } from "../Managers/BetManager";
import { AppContext } from "../../Common/AppContext";
import { PlayList } from "../Components/Sounds/PlayList";
import { ImageElement } from "../Components/Elements/Graphics/ImageElement";
import { PaylinesDefinitions } from "../GameComponents/PaylinesDefinitions";
import { TeasingBonus } from "./TeasingBonus";
import { BaseView } from "../GameComponents/Base/BaseView";

@engineComponent(ComponentTypes.DisplayObject)
export class WinAnimatorExtended extends WinAnimator {
    //******************************************************************************************************************
    //  TIMER STATUSES
    //******************************************************************************************************************

    protected static readonly FinishWinAnimatorTimer: string = "finishWinAnimatorTimer";

    //******************************************************************************************************************
    //  VARIABLES
    //******************************************************************************************************************

    protected elementInstance: Array<Object> = [];
    protected countBonusSymbolsOnReelsAndRows = 0;
    protected currentWinSymbolsContainer: ContainerElement;

    //******************************************************************************************************************
    //  CREATE, INITIALIZE
    //******************************************************************************************************************
    constructor() {
        super();
    }

    public initialize(
        symbols: Symbols,
        paylines?: Paylines,
        noWinSymbolsContainer?: ContainerElement,
        symbolsContainer?: ContainerElement,
    ): void {
        this.createTimer();

        this.createPaylines(paylines);
        //this.addChild(paylines);
        this.createSymbols(symbols, noWinSymbolsContainer, symbolsContainer);
        this.createAnimations();
    }

    /**
     *
     * @param {Object} element
     */
    public addElementInstance(element: Object): void {
        this.elementInstance[Object.keys(element)[0]] = element[Object.keys(element)[0]];
    }

    /**
     * Shows only bonus symbols with position tween into middle row. Other symbols hidden by animation.
     */
    public showOnlyBonusSymbols(): void {
        let bonusSymbolsPositions: Array<string> = [];
        for (let i = 0; i <= this.reelCount - 1; i++) {
            let cnt = 0;
            for (let j = 0; j < this.currentSymbols[i].length; j++) {
                if (this.currentSymbols[i][j] != null) {
                    if (
                        [
                            Settings.SymbolBonus,
                            Settings.SymbolBonus + 1,
                            Settings.SymbolBonus + 2,
                            Settings.SymbolBonus + 3,
                            Settings.SymbolBonus + 4,
                        ].indexOf(this.currentSymbols[i][j].id) >= 0
                    ) {
                        bonusSymbolsPositions.push(i + ";" + j);
                    } else {
                        this.currentSymbols[i][j].setDynamicTime(i * cnt * 6);
                        this.currentSymbols[i][j].goToCase("HIDE_DELAYED");
                        cnt++;
                    }
                }
            }
        }

        for (let i = 0; i < bonusSymbolsPositions.length; i++) {
            let position: string[] = bonusSymbolsPositions[i].split(";");
            let reelIndex = parseInt(position[0]);
            let symbolIndex = parseInt(position[1]);

            if (bonusSymbolsPositions.length == 3 || bonusSymbolsPositions.length == 4) {
                Tweens.removeTweens(this.currentSymbols[reelIndex][symbolIndex], "position");
                Tweens.positionTween(this.currentSymbols[reelIndex][symbolIndex], {
                    tweenX: [
                        this.currentSymbols[reelIndex][symbolIndex].position.x,
                        this.reelX[i + 1] - this.currentSymbols[reelIndex][symbolIndex].offsetX,
                    ],
                    tweenY: [
                        this.currentSymbols[reelIndex][symbolIndex].position.y,
                        this.reelY[0] + this.symbolHeight - this.currentSymbols[reelIndex][symbolIndex].offsetY,
                    ],
                    tweenDuration: 30,
                    tweenDelay: 45,
                    tweenEase: "backOut",
                });
            } else {
                Tweens.removeTweens(this.currentSymbols[reelIndex][symbolIndex], "position");
                Tweens.positionTween(this.currentSymbols[reelIndex][symbolIndex], {
                    tweenX: [
                        this.currentSymbols[reelIndex][symbolIndex].position.x,
                        this.reelX[i] - this.currentSymbols[reelIndex][symbolIndex].offsetX,
                    ],
                    tweenY: [
                        this.currentSymbols[reelIndex][symbolIndex].position.y,
                        this.reelY[0] + this.symbolHeight - this.currentSymbols[reelIndex][symbolIndex].offsetY,
                    ],
                    tweenDuration: 30,
                    tweenDelay: 45,
                    tweenEase: "backOut",
                });
            }
        }
    }

    /**
     *
     */
    public showExceptBonusSymbols(): void {
        for (let i = 0; i <= this.reelCount - 1; i++) {
            let cnt = 0;
            for (let j = 0; j < this.currentSymbols[i].length; j++) {
                if (this.currentSymbols[i][j] != null) {
                    if (
                        [
                            Settings.SymbolBonus,
                            Settings.SymbolBonus + 1,
                            Settings.SymbolBonus + 2,
                            Settings.SymbolBonus + 3,
                            Settings.SymbolBonus + 4,
                        ].indexOf(this.currentSymbols[i][j].id) >= 0
                    ) {
                        this.currentSymbols[i][j].goToCase(Symbol.CaseNormal);
                    } else {
                        this.currentSymbols[i][j].setDynamicTime(
                            (this.reelCount - 1 - i) * (this.currentSymbols[i].length - cnt) * 7,
                        );
                        this.currentSymbols[i][j].goToCase("SHOW_DELAYED");
                        cnt++;
                    }
                }
            }
        }
    }

    /**
     *
     * @param reelIndex
     * @param show
     */
    public showShadowUnderReelSymbols(reelIndex: number, show: boolean): void {
        for (let j = 0; j < this.currentSymbols[reelIndex].length; j++) {
            if (this.currentSymbols[reelIndex][j] != null) {
                if (show) {
                    this.currentSymbols[reelIndex][j].goToCase("HELD");
                } else {
                    this.currentSymbols[reelIndex][j].goToCase("NORMAL");
                }
            } else {
                if (DEBUG) {
                    this.log("ERROR Symbol doesn't exists!");
                }
            }
        }
    }

    /**
     *
     * @param spinBitmask
     */
    public highlightSymbolsOnHeldReels(spinBitmask: number): void {
        let heldReelsCounter: number = 0;

        for (let i = 0; i < this.reelCount; i++) {
            for (let j = 0; j < this.symbolCount; j++) {
                if (this.isReelHeld(spinBitmask, i)) {
                    // held reel
                    heldReelsCounter++;
                }
            }
        }

        if (heldReelsCounter > 0) {
            for (let i = 0; i < this.reelCount; i++) {
                for (let j = 0; j < this.symbolCount; j++) {
                    if (this.isReelHeld(spinBitmask, i)) {
                        // held reel
                        //this.currentSymbols[i][j].alpha = 1;
                        Tweens.removeTweens(this.currentSymbols[i][j], "all");
                        Tweens.alphaTween(this.currentSymbols[i][j], {
                            alphas: [this.currentSymbols[i][j].alpha, 1],
                            tweenDuration: 5,
                        });
                    } else {
                        //this.currentSymbols[i][j].alpha = 0.6;
                        Tweens.removeTweens(this.currentSymbols[i][j], "all");
                        Tweens.alphaTween(this.currentSymbols[i][j], {
                            alphas: [this.currentSymbols[i][j].alpha, 0.6],
                            tweenDuration: 5,
                        });
                    }
                }
            }
        } else {
            this.resetToOriginalAlpha();
        }
    }

    /**
     *
     * @param spinBitmask
     */
    public showPossibleWinsOnHeldReels(spinBitmask: number): Object {
        let paylineMatrix = this.preparePaylineMatrix(spinBitmask);

        return this.processSymbolsInPaylineMatrix(spinBitmask, paylineMatrix);
    }

    /**
     * Pripravi zakladny vzor na zaklade ne/holdnutych valcov.
     * @param spinBitmask
     */
    private preparePaylineMatrix(spinBitmask: number): Array<Array<number>> {
        let paylinesCount = this.paylines.getPaylines().length;
        let paylineMatrix: Array<Array<number>> = [];

        for (let paylineId = 1; paylineId <= paylinesCount; paylineId++) {
            paylineMatrix[paylineId] = [];
            const definition = PaylinesDefinitions.getPaylineDefinitionsById(
                paylineId,
                this.paylines.paylineDefinition,
            );
            for (let reelIndex = 0; reelIndex < this.reelCount; reelIndex++) {
                if (this.currentSymbols[reelIndex][definition[reelIndex]] != null) {
                    const symbol = this.currentSymbols[reelIndex][definition[reelIndex]];

                    if (this.isReelHeld(spinBitmask, reelIndex)) {
                        paylineMatrix[paylineId][reelIndex] = symbol.id;
                    } else {
                        paylineMatrix[paylineId][reelIndex] = -1;
                    }
                }
            }
        }

        return paylineMatrix;
    }

    /**
     *
     * @param spinBitmask
     * @param paylineMatrix
     */
    private processSymbolsInPaylineMatrix(spinBitmask: number, paylineMatrix: Array<Array<number>>): Object {
        let possibleMatrix: Array<Array<Array<number>>> = [];
        let possibleSymbolsOnReel: Array<Array<number>> = [];
        let possibleCounter: number;
        let paylinesCount = this.paylines.getPaylines().length;

        for (let paylineId = 1; paylineId <= paylinesCount; paylineId++) {
            const definition = PaylinesDefinitions.getPaylineDefinitionsById(
                paylineId,
                this.paylines.paylineDefinition,
            );
            possibleMatrix[paylineId] = [];

            // vyfiltruje vsetky okrem -1
            let filteredValues = paylineMatrix[paylineId].filter((value) => value > -1 && value != Settings.SymbolFox); // With wild expluded
            if (filteredValues.length == 0) {
                filteredValues = paylineMatrix[paylineId].filter((value) => value > -1); // Try again with wild expluded
            }

            if (filteredValues.length > 0) {
                let possibleSymbol = filteredValues[0];

                // nahradi -1 a wild za prvy z vyfiltrovanych
                possibleCounter = 0;
                paylineMatrix[paylineId].forEach((value, index) => {
                    if (value == -1 || value == Settings.SymbolFox) {
                        paylineMatrix[paylineId][index] = possibleSymbol;
                    }
                });

                // skontroluje pritomntost trojic, stvoric, patic
                for (let i = 0; i < paylineMatrix[paylineId].length; i++) {
                    if (paylineMatrix[paylineId][i] == possibleSymbol) {
                        possibleCounter++;
                    } else {
                        break;
                    }
                }
                // ak je mozna najmenej trojica, nasetuje valcom possibleSymboly
                if (possibleCounter >= 3) {
                    for (let reelIndex = 0; reelIndex < possibleCounter; reelIndex++) {
                        possibleMatrix[paylineId][reelIndex] = [];

                        if (possibleSymbolsOnReel[reelIndex] == undefined) {
                            possibleSymbolsOnReel[reelIndex] = [];
                        }
                        if (possibleSymbolsOnReel[reelIndex].indexOf(possibleSymbol) === -1) {
                            possibleSymbolsOnReel[reelIndex].push(possibleSymbol);
                        }
                        // Add wild symbol into possible symbols
                        if (possibleSymbolsOnReel[reelIndex].indexOf(Settings.SymbolFox) === -1) {
                            possibleSymbolsOnReel[reelIndex].push(Settings.SymbolFox);
                        }

                        if (this.isReelHeld(spinBitmask, reelIndex)) {
                            possibleMatrix[paylineId][reelIndex][definition[reelIndex]] = 1;
                        }
                    }
                }
            } else {
                possibleSymbolsOnReel = this.resetAndReturnPossibleSymbolsOnReel();
            }
        }

        this.highlightPossibleSymbolsOnReels(spinBitmask, possibleMatrix);

        return { possibleSymbolsOnReel: possibleSymbolsOnReel };
    }

    /**
     *
     */
    public resetAndReturnPossibleSymbolsOnReel(): Array<Array<number>> {
        let possibleSymbolsOnReel: Array<Array<number>> = [];

        for (let reelIndex = 0; reelIndex < this.reelCount; reelIndex++) {
            if (possibleSymbolsOnReel[reelIndex] == undefined) {
                possibleSymbolsOnReel[reelIndex] = [];
            }

            this.symbols.symbols.forEach((symbol: Symbol) => {
                if (possibleSymbolsOnReel[reelIndex].indexOf(symbol.id) === -1) {
                    possibleSymbolsOnReel[reelIndex].push(symbol.id);
                }
            }, this);
        }

        return possibleSymbolsOnReel;
    }

    /**
     *
     */
    public highlightPossibleSymbolsOnReels(spinBitmask: number, possibleMatrix: Array<Array<Array<number>>>): void {
        let showPayLines = false;
        let paylinesCount = this.paylines.getPaylines().length;
        let heldReelsCounter = this.getCountOfHeldReels(spinBitmask);
        let bonusSymbolsCounter = this.getCountOfBonusSymbolsOnHeldReels(spinBitmask);

        if (showPayLines) {
            this.paylines.reset();
        }

        /**
         * Set symbols
         */
        for (let i = 0; i < this.reelCount; i++) {
            for (let j = 0; j < this.symbolCount; j++) {
                if (this.currentSymbols[i][j] != null) {
                    if (spinBitmask < 31) {
                        // condition for minimum of held reels
                        if (this.isReelHeld(spinBitmask, i)) {
                            // HELD reel
                            if (
                                [
                                    Settings.SymbolBonus,
                                    Settings.SymbolBonus + 1,
                                    Settings.SymbolBonus + 2,
                                    Settings.SymbolBonus + 3,
                                    Settings.SymbolBonus + 4,
                                ].indexOf(this.currentSymbols[i][j].id) >= 0
                            ) {
                                if (this.reelCount - heldReelsCounter + bonusSymbolsCounter >= 3) {
                                    this.currentSymbols[i][j].goToCase("HELD");
                                } else {
                                    this.currentSymbols[i][j].goToCase("IMPOSSIBLE_WIN");
                                }
                            } else {
                                for (let paylineId = 1; paylineId <= paylinesCount; paylineId++) {
                                    if (
                                        possibleMatrix[paylineId] === undefined ||
                                        possibleMatrix[paylineId][i] === undefined ||
                                        possibleMatrix[paylineId][i][j] === undefined
                                    ) {
                                        // if symbol is not in possible combination
                                        this.currentSymbols[i][j].goToCase("IMPOSSIBLE_WIN");
                                    } else {
                                        this.currentSymbols[i][j].goToCase("HELD");

                                        if (showPayLines) {
                                            this.paylines.goToCase("POSSIBLE_WIN", paylineId);
                                        }
                                        break;
                                    }
                                }
                            }
                        } else {
                            for (let paylineId = 1; paylineId <= paylinesCount; paylineId++) {
                                if (
                                    possibleMatrix[paylineId] === undefined ||
                                    possibleMatrix[paylineId][i] === undefined ||
                                    possibleMatrix[paylineId][i][j] === undefined
                                ) {
                                    // if symbol is not in possible combination
                                    this.currentSymbols[i][j].goToCase("IMPOSSIBLE_WIN");
                                } else {
                                    this.currentSymbols[i][j].goToCase("NORMAL");
                                    if (showPayLines) {
                                        this.paylines.goToCase("POSSIBLE_WIN", paylineId);
                                    }
                                    break;
                                }
                            }
                        }
                    } else {
                        // turn back alpha
                        this.currentSymbols[i][j].goToCase("NORMAL");
                    }
                }
            }
        }
    }

    /**
     *
     * @param spinBitmask
     * @param possibleSymbolsIds
     * @param reelIndex
     */
    public highlightPossibleSymbolsOnReelsByIds(
        spinBitmask: number,
        possibleSymbolsIds: Array<number>,
        reelIndex: number,
    ): void {
        let bonusTeasing = false;
        if (this.elementInstance["teasing"] != null) {
            this.elementInstance["teasing"].forEach((teasingComponent: TeasingComponentAbstract) => {
                if (teasingComponent instanceof TeasingBonus) {
                    if (teasingComponent.teasingEnabled) {
                        bonusTeasing = true;
                    }
                }
            }, this);
        }

        if (!bonusTeasing) {
            //for (let i = 0; i < this.reelCount; i++) {
            for (let j = 0; j < this.symbolCount; j++) {
                if (this.currentSymbols[reelIndex][j] != null) {
                    if (spinBitmask < 31) {
                        // condition for minimum of held reels
                        if (!this.isReelHeld(spinBitmask, reelIndex)) {
                            if (
                                possibleSymbolsIds == undefined ||
                                (possibleSymbolsIds != undefined &&
                                    possibleSymbolsIds.indexOf(this.currentSymbols[reelIndex][j].id) === -1)
                            ) {
                                this.currentSymbols[reelIndex][j].goToCase("IMPOSSIBLE_WIN");
                            } else {
                                this.currentSymbols[reelIndex][j].goToCase("NORMAL");
                            }
                        }
                    } else {
                        this.currentSymbols[reelIndex][j].goToCase("NORMAL");
                    }
                }
            }
            //}
        }
    }

    /**
     *
     * @param spinBitmask
     * @param reelIndex
     */
    isReelHeld(spinBitmask: number, reelIndex: number): boolean {
        return (spinBitmask & (1 << reelIndex)) === 0;
    }

    /**
     * Get count of held reels.
     * @param spinBitmask
     */
    getCountOfHeldReels(spinBitmask: number): number {
        let heldReelsCounter = 0;
        for (let i = 0; i < this.reelCount; i++) {
            if (this.isReelHeld(spinBitmask, i)) {
                heldReelsCounter++;
            }
        }

        return heldReelsCounter;
    }

    /**
     *
     */
    getCountOfBonusSymbolsOnHeldReels(spinBitmask: number): number {
        let bonusSymbolsCounter = 0;
        for (let i = 0; i < this.reelCount; i++) {
            for (let j = 0; j < this.symbolCount; j++) {
                if (this.isReelHeld(spinBitmask, i)) {
                    // HELD reel
                    if (this.currentSymbols[i][j] != null) {
                        if (
                            [
                                Settings.SymbolBonus,
                                Settings.SymbolBonus + 1,
                                Settings.SymbolBonus + 2,
                                Settings.SymbolBonus + 3,
                                Settings.SymbolBonus + 4,
                            ].indexOf(this.currentSymbols[i][j].id) >= 0
                        ) {
                            bonusSymbolsCounter++;
                        }
                    }
                }
            }
        }

        return bonusSymbolsCounter;
    }

    /**
     *
     */
    resetToOriginalAlpha(): void {
        for (let i = 0; i < this.reelCount; i++) {
            for (let j = 0; j < this.symbolCount; j++) {
                if (this.currentSymbols[i][j] != null) {
                    //this.currentSymbols[i][j].alpha = 1;
                } else {
                    if (DEBUG) {
                        this.log("ERROR Symbol doesn't exists!");
                    }
                }
            }
        }
    }

    //******************************************************************************************************************
    //  ON REEL STOPPED, SHOW SYMBOLS
    //******************************************************************************************************************

    /**
     *
     * @param {Array<"neo-games/Engine/Communication/Game/Types/IReel".IReel>} reelsData
     * @param {number} reelIndex
     * @param {boolean} force
     * @returns {boolean} Returns true if all symbols on reel are the same.
     */
    public onReelStopped(
        reelsData: Array<Communication.Game.IReel>,
        reelIndex: number,
        force = false,
        spinBitmask: number = 31,
    ): boolean {
        super.onReelStopped(reelsData, reelIndex);

        let fullOfTheSameSymbol = false;

        if (!force) {
            if (this.elementInstance["teasing"] != null) {
                let sta: Array<Array<ISymbolTeasingAttributes>>;

                this.elementInstance["teasing"].forEach(function (teasingComponent: TeasingComponentAbstract) {
                    let symbolsTeasingAttributes = teasingComponent.setSymbolsTeasingAttributes(reelIndex);
                    if (teasingComponent.teasingEnabled) {
                        sta = symbolsTeasingAttributes;
                    }
                }, this);

                for (let i = 0; i < this.reelCount; i++) {
                    for (let j = 0; j < this.currentSymbols[i].length; j++) {
                        if (this.currentSymbols[i][j] != null) {
                            if (typeof sta !== "undefined") {
                                if (sta[i][j].action === SymbolTeasingActions.NOWIN) {
                                    if (this.isReelHeld(spinBitmask, i)) {
                                        if (BaseView.PossibleSymbolsOnReel[reelIndex] != null) {
                                            if (
                                                BaseView.PossibleSymbolsOnReel[reelIndex].length == 0 ||
                                                (BaseView.PossibleSymbolsOnReel[reelIndex].length > 0 &&
                                                    BaseView.PossibleSymbolsOnReel[reelIndex].indexOf(
                                                        this.currentSymbols[i][j].id,
                                                    ) === -1)
                                            ) {
                                                if (this.allowSymbolGoToCase(i, j, "IMPOSSIBLE_WIN")) {
                                                    this.currentSymbols[i][j].goToCase("IMPOSSIBLE_WIN");
                                                }
                                            } else {
                                                if (this.currentSymbols[i][j].getCurrentCase() !== "IMPOSSIBLE_WIN") {
                                                    if (this.allowSymbolGoToCase(i, j, "HELD")) {
                                                        this.currentSymbols[i][j].goToCase("HELD");
                                                    }
                                                }
                                            }
                                        }
                                    } else {
                                        if (this.allowSymbolGoToCase(i, j, Symbol.CaseNowin)) {
                                            this.currentSymbols[i][j].goToCase(Symbol.CaseNowin);
                                        }
                                    }
                                } else if (sta[i][j].action === SymbolTeasingActions.NORMAL) {
                                    if (this.isReelHeld(spinBitmask, i)) {
                                        if (this.allowSymbolGoToCase(i, j, "HELD")) {
                                            this.currentSymbols[i][j].goToCase("HELD");
                                        }
                                    } else {
                                        if (this.allowSymbolGoToCase(i, j, Symbol.CaseNormal)) {
                                            this.currentSymbols[i][j].goToCase(Symbol.CaseNormal);
                                        }
                                    }
                                } else if (sta[i][j].action === SymbolTeasingActions.IMPACT) {
                                    if (this.allowSymbolGoToCase(i, j, Symbol.CaseImpact)) {
                                        this.currentSymbols[i][j].goToCase(Symbol.CaseImpact);
                                    }
                                } else if (sta[i][j].action === SymbolTeasingActions.TEASE) {
                                    if (this.allowSymbolGoToCase(i, j, Symbol.CaseTease)) {
                                        this.currentSymbols[i][j].goToCase(Symbol.CaseTease);
                                    }
                                } else if (sta[i][j].action === SymbolTeasingActions.EMPTY) {
                                    if (this.allowSymbolGoToCase(i, j, Symbol.CaseEmpty)) {
                                        this.currentSymbols[i][j].goToCase(Symbol.CaseEmpty);
                                    }
                                }
                            } else {
                                if (this.allowSymbolGoToCase(i, j, Symbol.CaseNormal)) {
                                    if (this.currentSymbols[i][j].id === Settings.SymbolFox) {
                                        this.currentSymbols[i][j].goToCase("IMPACT");
                                    } else {
                                        //this.currentSymbols[i][j].goToCase(Symbol.CaseNormal);
                                    }
                                }
                            }
                        }
                    }
                }
            }

            // If reel is full of the same symbol
            /*if (this.currentSymbols[reelIndex][0].id === this.currentSymbols[reelIndex][1].id
                && this.currentSymbols[reelIndex][1].id === this.currentSymbols[reelIndex][2].id) {
                fullOfTheSameSymbol = true;
            }*/
        }

        // count bonus symbols on screen and play sound
        let bonusSymbolOnReel = false;
        for (let j = 0; j < this.currentSymbols[reelIndex].length; j++) {
            if (this.currentSymbols[reelIndex][j] != null) {
                if (
                    [
                        Settings.SymbolBonus,
                        Settings.SymbolBonus + 1,
                        Settings.SymbolBonus + 2,
                        Settings.SymbolBonus + 3,
                        Settings.SymbolBonus + 4,
                    ].indexOf(this.currentSymbols[reelIndex][j].id) >= 0
                ) {
                    bonusSymbolOnReel = true;
                    this.countBonusSymbolsOnReelsAndRows++;
                }
            }
            if (bonusSymbolOnReel && this.countBonusSymbolsOnReelsAndRows > 0) {
                PlayList.play("SND_BaseBonusHit0" + this.countBonusSymbolsOnReelsAndRows);
            }
        }

        /*if (this.currentReels[reelIndex].symbols.indexOf(Settings.SymbolWitch) != -1) {
            PlayList.play('SND_BaseWildStop');
        }*/

        return fullOfTheSameSymbol;
    }

    /**
     * Set attributes before WinAnimatorExtended.onReelStopped() call.
     */
    public setSymbolsTeasingAttributes(spinBitmask: number): void {
        for (let reelIndex = 0; reelIndex < this.reelCount; reelIndex++) {
            if (this.elementInstance["teasing"] != null) {
                let sta: Array<Array<ISymbolTeasingAttributes>>;

                this.elementInstance["teasing"].forEach(function (teasingComponent: TeasingComponentAbstract) {
                    let symbolsTeasingAttributes = teasingComponent.setSymbolsTeasingAttributesPrePhase(reelIndex);
                    if (teasingComponent.teasingEnabled) {
                        sta = symbolsTeasingAttributes;
                    }
                }, this);

                for (let j = 0; j < this.currentSymbols[reelIndex].length; j++) {
                    if (this.currentSymbols[reelIndex][j] != null) {
                        if (typeof sta !== "undefined") {
                            if (sta[reelIndex][j].action === SymbolTeasingActions.NOWIN) {
                                if (this.isReelHeld(spinBitmask, reelIndex)) {
                                    if (BaseView.PossibleSymbolsOnReel[reelIndex] != null) {
                                        if (
                                            BaseView.PossibleSymbolsOnReel[reelIndex].length === 0 ||
                                            (BaseView.PossibleSymbolsOnReel[reelIndex].length > 0 &&
                                                BaseView.PossibleSymbolsOnReel[reelIndex].indexOf(
                                                    this.currentSymbols[reelIndex][j].id,
                                                ) === -1)
                                        ) {
                                            if (this.allowSymbolGoToCase(reelIndex, j, "IMPOSSIBLE_WIN")) {
                                                this.currentSymbols[reelIndex][j].goToCase("IMPOSSIBLE_WIN");
                                            }
                                        } else {
                                            if (this.allowSymbolGoToCase(reelIndex, j, "HELD")) {
                                                this.currentSymbols[reelIndex][j].goToCase("HELD");
                                            }
                                        }
                                    }
                                } else {
                                    if (this.allowSymbolGoToCase(reelIndex, j, Symbol.CaseNowin)) {
                                        this.currentSymbols[reelIndex][j].goToCase(Symbol.CaseNowin);
                                    }
                                }
                            }
                        }

                        if (
                            [
                                Settings.SymbolBonus,
                                Settings.SymbolBonus + 1,
                                Settings.SymbolBonus + 2,
                                Settings.SymbolBonus + 3,
                                Settings.SymbolBonus + 4,
                            ].indexOf(this.currentSymbols[reelIndex][j].id) >= 0
                        ) {
                            this.countBonusSymbolsOnReelsAndRows++;
                        }
                    }
                }
            }
        }
    }

    //******************************************************************************************************************
    //  SHOW WINS
    //******************************************************************************************************************

    protected showFirstWins(): void {
        this.allSymbolsGoToCase(Symbol.CaseNowin, true);
        this.allPaylinesGoToCase(Payline.CaseNowin);

        let hasCashWin: boolean = false;
        for (let i = 0; i < this.currentWins.length; i++) {
            this.winSymbolsGoToCase(i, Symbol.CaseWin, false);
            this.winPaylineGoToCase(i, Payline.CaseWin);

            if (this.currentWins[i].trigger === Communication.Game.WinTrigger.Payline) {
                if (this.currentWins[i].type == Communication.Game.WinType.Cash) {
                    hasCashWin = true;
                }
            }
        }

        if (hasCashWin) {
            this.startAnimation();
        } else {
            this.startTimer(WinAnimatorExtended.FinishWinAnimatorTimer, 60);
        }

        if (this.currentMultiplierIndex >= 3) {
            if (this.elementInstance["Logo"] != null && this.elementInstance["Logo"] instanceof SwitchElement) {
                this.elementInstance["Logo"].goToCase("WIN");
            }
            if (this.elementInstance["Overlay"] != null) {
                Tweens.removeTweens(this.elementInstance["Overlay"]);
                Tweens.alphaTween(this.elementInstance["Overlay"], {
                    alphas: [0, 0.6],
                    tweenDuration: 30,
                });
            }
            if (this.elementInstance["Speaker"] != null && this.elementInstance["Speaker"] instanceof SwitchElement) {
                this.elementInstance["Speaker"].goToCase("HIGHWIN_INTRO");
            }
            if (this.elementInstance["Rooster"] != null && this.elementInstance["Rooster"] instanceof SwitchElement) {
                this.elementInstance["Rooster"].goToCase("HIGHWIN_INTRO");
            }
        } else {
            if (this.elementInstance["Rooster"] != null && this.elementInstance["Rooster"] instanceof SwitchElement) {
                this.elementInstance["Rooster"].goToCase("WIN");
            }
        }
    }

    protected cycleWins(): void {
        if (this.currentWins == null) {
            return;
        }

        this.allPaylinesGoToCase(Payline.CaseNowin);

        for (let i = 0; i < this.currentWins.length; i++) {
            this.winSymbolsGoToCase(i, Symbol.CaseNormal, false);
            this.winPaylineGoToCase(i, Payline.CaseNormal);
        }

        this.winSymbolsGoToCase(this.currentCycle, Symbol.CaseCycle, true);
        this.winPaylineGoToCase(this.currentCycle, Payline.CaseCycle);

        this.currentCycle = (this.currentCycle + 1) % this.currentWins.length;

        this.startTimer(WinAnimator.CycleWins, this.getCycleWinsDelay());
    }

    //******************************************************************************************************************
    //  RESET
    //******************************************************************************************************************

    public reset(showLastSymbols: boolean, spin = false, spinBitmask = 0): boolean {
        if (this.elementInstance["Logo"] != null && this.elementInstance["Logo"] instanceof SwitchElement) {
            this.elementInstance["Logo"].goToCase("NORMAL");
        }
        if (this.elementInstance["Overlay"] != null) {
            Tweens.removeTweens(this.elementInstance["Overlay"]);
            this.elementInstance["Overlay"].alpha = 0;
        }
        if (this.elementInstance["Speaker"] != null && this.elementInstance["Speaker"] instanceof SwitchElement) {
            this.elementInstance["Speaker"].goToCase("OUTRO");
        }
        if (this.elementInstance["Rooster"] != null && this.elementInstance["Rooster"] instanceof SwitchElement) {
            if (
                ["IDLE", "IDLE_2", "IDLE_3", "IDLE_4"].indexOf(this.elementInstance["Rooster"].getCurrentCase()) === -1
            ) {
                this.elementInstance["Rooster"].goToCase("IDLE");
            }
        }

        this.countBonusSymbolsOnReelsAndRows = 0;

        // Timer
        this.stopTimer();

        if (!this.enabledRespin()) {
            this.allSymbolsGoToCase(showLastSymbols ? Symbol.CaseNormal : Symbol.CaseEmpty, false);
            this.allPaylinesGoToCase(Payline.CaseNormal);
            this.resetToOriginalAlpha();
        }

        if (showLastSymbols && !spin) {
            this.startTimer(WinAnimator.Idle, this.getInitialIdleDelay());
        }

        this.value.visible = false;

        let lastMultiplierIndex = this.currentMultiplierIndex;
        this.currentMultiplierIndex = -1;

        if (this.currentAnimationIndex != null) {
            if (this.currentAnimationFinished) {
                this.resetAnimations();

                this.currentWins = null;
                this.currentWin = null;

                return false;
            } else {
                this.stopAnimation();

                this.currentWins = null;
                this.currentWin = null;

                return lastMultiplierIndex >= 3;
            }
        } else {
            this.currentWins = null;
            this.currentWin = null;

            return lastMultiplierIndex >= 3;
        }
    }

    resetTimer(): void {
        this.stopTimer();

        if (!this.currentAnimationFinished) {
            this.stopAnimation();
        }
    }

    protected allSymbolsOnRespinReelGoToEmpty(idsHolders: Array<boolean>): void {
        let caseType = Symbol.CaseNormal;

        for (let i = 0; i < idsHolders.length; i++) {
            if (!idsHolders[i]) {
                for (let j = this.currentSymbols[i].length - 1; j >= 0; j--) {
                    const symbol = this.currentSymbols[i][j];

                    if (symbol !== null && this.allowSymbolGoToCase(i, j, caseType)) {
                        symbol.goToCase(caseType);
                        this.symbolsContainer.addChild(symbol);
                    }
                }
            }
        }
    }

    //******************************************************************************************************************
    //  TIMER
    //******************************************************************************************************************

    protected onTimerComplete(): void {
        super.onTimerComplete();

        switch (this.timerStatus) {
            case WinAnimatorExtended.FinishWinAnimatorTimer:
                this.emit(WinAnimator.FinishWinAnimator);
                break;
        }
    }

    //******************************************************************************************************************
    //  SYMBOLS
    //******************************************************************************************************************

    protected createSymbols(
        symbols: Symbols,
        noWinSymbolsContainer: ContainerElement,
        symbolsContainer: ContainerElement,
    ): void {
        this.symbols = symbols;

        if (noWinSymbolsContainer != null) {
            this.noWinSymbolsContainer = noWinSymbolsContainer;
        } else {
            this.noWinSymbolsContainer = new ContainerElement();
            this.noWinSymbolsContainer.name = "NoWinSymbols";

            this.addChild(this.noWinSymbolsContainer);
        }

        if (symbolsContainer != null) {
            this.symbolsContainer = symbolsContainer;
        } else {
            this.symbolsContainer = new ContainerElement();
            this.symbolsContainer.name = "Symbols";

            this.addChild(this.symbolsContainer);
        }

        if (
            this.elementInstance["CurrentWinSymbolsContainer"] != null &&
            this.elementInstance["CurrentWinSymbolsContainer"] instanceof ContainerElement
        ) {
            this.currentWinSymbolsContainer = this.elementInstance["CurrentWinSymbolsContainer"];
        }

        this.currentSymbols = [];

        for (let i = 0; i < this.reelCount; i++) {
            this.currentSymbols.push([]);

            for (let j = 0; j < this.symbolCount; j++) {
                this.currentSymbols[i].push(null);
            }
        }
    }

    protected addCurrentSymbol(reelIndex: number, symbolIndex: number): void {
        if (this.currentSymbols[reelIndex][symbolIndex] === null) {
            let id = this.currentReels[reelIndex].symbols[symbolIndex];
            if (id == Settings.SymbolBonus) {
                // Every reel has different color of bonus symbol
                id += reelIndex;
            }

            const symbol = this.symbols.getSymbol(id - 1, Symbol.CaseNormal);
            symbol.position.x = this.reelX[reelIndex] - symbol.offsetX;
            symbol.position.y = this.reelY[reelIndex] + this.symbolHeight * symbolIndex - symbol.offsetY;

            this.symbolsContainer.addChild(symbol);

            this.currentSymbols[reelIndex][symbolIndex] = symbol;
        }

        this.sortChildrenByZindex();
    }

    /**
     *
     * @param {string} caseType
     * @param {boolean} noWin
     */
    protected allSymbolsGoToCase(caseType: string, noWin: boolean): void {
        super.allSymbolsGoToCase(caseType, noWin);
        this.sortChildrenByZindex();
    }

    protected winSymbolsGoToCaseAsPayline(winIndex: number, caseType: string): Array<Symbol> {
        const win = this.currentWins[winIndex];
        const symbols: Array<Symbol> = [];

        if (this.paylines != null) {
            const definition = PaylinesDefinitions.getPaylineDefinitionsById(
                win.paylineId,
                this.paylines.paylineDefinition,
            );

            for (let i = 0; i < definition.length; i++) {
                if (win.mask[i] === 1 && this.allowSymbolGoToCase(i, definition[i], caseType)) {
                    const symbol = this.currentSymbols[i][definition[i]];
                    symbol.goToCase(caseType);

                    if (caseType == Symbol.CaseCycle) {
                        this.currentWinSymbolsContainer.addChild(symbol);
                    } else {
                        this.symbolsContainer.addChild(symbol);
                    }

                    symbols.push(symbol);
                }
            }
        }

        return symbols;
    }

    protected allowSymbolGoToCase(reelIndex: number, symbolIndex: number, caseType: string): boolean {
        return this.currentSymbols[reelIndex][symbolIndex].getCurrentCase() !== caseType;
    }

    /**
     * Sorts children of container by symbols zIndex attribute.
     */
    protected sortChildrenByZindex(): void {
        this.symbolsContainer.children.sort((a: any, b: any) => {
            if (a.hasOwnProperty("zIndex") && b.hasOwnProperty("zIndex")) {
                a.zIndex = a.zIndex || 0;
                b.zIndex = b.zIndex || 0;

                return a.zIndex - b.zIndex;
            }

            return 0;
        });

        this.noWinSymbolsContainer.children.sort((a: any, b: any) => {
            if (a.hasOwnProperty("zIndex") && b.hasOwnProperty("zIndex")) {
                a.zIndex = a.zIndex || 0;
                b.zIndex = b.zIndex || 0;

                return a.zIndex - b.zIndex;
            }

            return 0;
        });
    }

    //******************************************************************************************************************
    //  ANIMATIONS
    //******************************************************************************************************************

    protected createAnimations(): void {
        // Animations
        if (this.elementInstance["WinAnimations"] != null) {
            this.animationsContainer = this.elementInstance["WinAnimations"];
        } else {
            this.animationsContainer = new ContainerElement();
            this.animationsContainer.name = "WinAnimations";

            this.addChild(this.animationsContainer);
        }

        if (this.childs["Value"]) {
            this.value = this.childs["Value"];

            if (this.animationsContainer != null) {
                this.animationsContainer.addChild(this.value);
            }
        }

        this.animations = [];

        for (let i = 0; i < this.animationNames.length; i++) {
            if (this.childs[this.animationNames[i]]) {
                let animation = this.childs[this.animationNames[i]];

                /*if (["BigWin", "EpicWin", "LegendaryWin"].indexOf(animation.name) ) {
                    if(AppContext.gameDefinition.ClientHostType === 'Mobile') {
                        let childs: Object = (animation.children[0] as ContainerElement).childs;
                        if (childs['Spotlight_LeftMask'] != null) {
                            delete childs['Spotlight_LeftMask'];
                        }
                    }
                }*/

                animation.visible = false;
                animation.on("big", this.onBigWin.bind(this));
                animation.on("epic", this.onEpicWin.bind(this));
                animation.on("legendary", this.onLegendaryWin.bind(this));
                animation.on("finished", this.onAnimationFinished.bind(this));
                animation.on("calculationFinished", this.onCalculationFinished.bind(this));
                animation.on(TimelineElement.AnimationComplete, this.onAnimationComplete.bind(this));
                this.animations.push(animation);

                if (this.animationsContainer != null) {
                    this.animationsContainer.addChild(animation);
                }
            }
        }

        this.currentAnimationIndex = null;
        this.currentAnimationFinished = true;
    }

    protected startAnimation(): void {
        this.currentAnimationIndex = this.getAnimationIndex();
        this.currentAnimationFinished = false;

        const animation = this.animations[this.currentAnimationIndex];
        animation.visible = true;

        if (this.currentAnimationIndex >= 3) {
            animation.setDynamicTimeFrames(30).updateDynamicTimeFrames();
        }

        if (AppContext.gameConfiguration.UseCoins && BetManager.CoinSize != null) {
            ImageTextCounterElement.Round = true;
            animation.play(parseInt(NumberUtils.devide(this.currentWin, BetManager.CoinSize).toString()));
        } else {
            ImageTextCounterElement.Round = false;
            animation.play(this.currentWin);
        }
    }

    protected stopAnimation(): void {
        super.stopAnimation();

        if (this.currentMultiplierIndex >= 3) {
            if (this.elementInstance["Logo"] != null && this.elementInstance["Logo"] instanceof SwitchElement) {
                this.elementInstance["Logo"].goToCase("NORMAL");
            }
            if (this.elementInstance["Overlay"] != null) {
                this.elementInstance["Overlay"].alpha = 0;
            }
            if (this.elementInstance["Speaker"] != null && this.elementInstance["Speaker"] instanceof SwitchElement) {
                this.elementInstance["Speaker"].goToCase("OUTRO");
            }
            /*if (this.elementInstance['Rooster'] != null && this.elementInstance['Rooster'] instanceof SwitchElement) {
                this.elementInstance['Rooster'].goToCase('HIGHWIN_OUTRO');
            }*/
        }
    }

    /**
     *
     */
    protected onBigWin(): void {
        /*if (this.elementInstance['Speaker'] != null && this.elementInstance['Speaker'] instanceof SwitchElement) {
            this.elementInstance['Speaker'].goToCase('LOOP');
            this.elementInstance['Speaker'].goToCase('LOOP_ELECTRIC');
        }*/
        /*if (this.elementInstance['Rooster'] != null && this.elementInstance['Rooster'] instanceof SwitchElement) {
            this.elementInstance['Rooster'].goToCase('HIGHWIN_OUTRO');
        }*/
    }

    /**
     *
     */
    protected onEpicWin(): void {
        /*if (this.elementInstance['Speaker'] != null && this.elementInstance['Speaker'] instanceof SwitchElement) {
            this.elementInstance['Speaker'].goToCase('LOOP');
            this.elementInstance['Speaker'].goToCase('LOOP_ELECTRIC');
        }*/
        if (this.elementInstance["Rooster"] != null && this.elementInstance["Rooster"] instanceof SwitchElement) {
            this.elementInstance["Rooster"].goToCase("HIGHWIN_LOOP_2");
        }
    }

    /**
     *
     */
    protected onLegendaryWin(): void {
        /*if (this.elementInstance['Speaker'] != null && this.elementInstance['Speaker'] instanceof SwitchElement) {
            this.elementInstance['Speaker'].goToCase('LOOP');
            this.elementInstance['Speaker'].goToCase('LOOP_ELECTRIC');
        }*/
        if (this.elementInstance["Rooster"] != null && this.elementInstance["Rooster"] instanceof SwitchElement) {
            this.elementInstance["Rooster"].goToCase("HIGHWIN_LOOP_3");
        }
    }

    protected onAnimationFinished(): void {
        super.onAnimationFinished();

        if (this.currentMultiplierIndex >= 3) {
            if (this.elementInstance["Logo"] != null && this.elementInstance["Logo"] instanceof SwitchElement) {
                this.elementInstance["Logo"].goToCase("NORMAL");
            }
            if (this.elementInstance["Overlay"] != null) {
                Tweens.removeTweens(this.elementInstance["Overlay"]);
                Tweens.alphaTween(this.elementInstance["Overlay"], {
                    alphas: [this.elementInstance["Overlay"].alpha, 0],
                    tweenDuration: 60,
                    tweenDelay: 60,
                });
            }
            if (this.elementInstance["Speaker"] != null && this.elementInstance["Speaker"] instanceof SwitchElement) {
                this.elementInstance["Speaker"].goToCase("OUTRO");
            }
            if (this.elementInstance["Rooster"] != null && this.elementInstance["Rooster"] instanceof SwitchElement) {
                this.elementInstance["Rooster"].goToCase("HIGHWIN_OUTRO");
            }
        } else {
            /*if (this.elementInstance['Rooster'] != null && this.elementInstance['Rooster'] instanceof SwitchElement) {
                this.elementInstance['Rooster'].goToCase('WIN_OUTRO');
            }*/
        }
    }

    //******************************************************************************************************************
    //  IDLE
    //******************************************************************************************************************

    protected idle(): void {
        if (!this.enabledRespin()) {
            for (let i = 0; i < this.getIdleActiveElementsCount(); i++) {
                const symbol =
                    this.currentSymbols[Math.floor(Math.random() * this.reelCount)][
                        Math.floor(Math.random() * this.symbolCount)
                    ];

                if (symbol.getCurrentCase() === Symbol.CaseNormal) {
                    if (symbol.hasCase(Symbol.CaseIdle)) {
                        symbol.goToCase(Symbol.CaseIdle);
                    }
                }
            }
        }

        this.startTimer(WinAnimator.Idle, this.getIdleDelay());

        if (this.elementInstance["Rooster"] != null && this.elementInstance["Rooster"] instanceof SwitchElement) {
            if (
                ["IDLE", "IDLE_2", "IDLE_3", "IDLE_4"].indexOf(this.elementInstance["Rooster"].getCurrentCase()) === -1
            ) {
                this.elementInstance["Rooster"].goToCase("IDLE");
            }
        }

        if (this.elementInstance["Butterflies"] != null) {
            for (let j = 0; j < this.elementInstance["Butterflies"].length; j++) {
                if (this.elementInstance["Butterflies"][j] instanceof SwitchElement) {
                    if (["EMPTY"].indexOf(this.elementInstance["Butterflies"][j].getCurrentCase()) !== -1) {
                        this.elementInstance["Butterflies"][j].goToCase("IDLE");
                    }
                }
            }
        }
    }

    /**
     * @returns {boolean}
     */
    enabledRespin(): boolean {
        return (
            GameManager.baseResponse != null &&
            GameManager.baseResponse.respin != null &&
            GameManager.baseResponse.respin !== 0 &&
            GameManager.baseResponse.spinId === 0
        );
    }

    /**
     *
     * @returns {boolean}
     */
    activeRespin(): boolean {
        return (
            GameManager.baseResponse != null &&
            GameManager.baseResponse.respin != null &&
            GameManager.baseResponse.respin !== 0 &&
            GameManager.baseResponse.spinId > 0
        );
    }

    /**
     *
     * @returns {Array<number>}
     */
    getReelsInRespin(): Array<number> {
        let reelsInRespin: Array<number> = [];

        if (GameManager.baseResponse.respin != null) {
            if (GameManager.baseResponse.respin === 1) {
                reelsInRespin.push(0);
            } else if (GameManager.baseResponse.respin === 2) {
                reelsInRespin.push(1);
            } else if (GameManager.baseResponse.respin === 4) {
                reelsInRespin.push(2);
            }
        }

        return reelsInRespin;
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/WinAnimatorExtended.ts
 **/